export enum AdminPartnersFilterEnum {
  Member = 'member',
}
